import React, {useRef, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './FarmCalculator.css'
import { Link } from 'react-router-dom';
import { PoultryCompileIcon } from '../assets/IconSvg';

const FarmCalculator = () => {
  const cardContainerRef = useRef(null);

  useEffect(() => {
    const cardContainer = cardContainerRef.current;

    if (!cardContainer) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      cardContainer.classList.add('active');
      startX = e.pageX - cardContainer.offsetLeft;
      scrollLeft = cardContainer.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      cardContainer.classList.remove('active');
    };

    const handleMouseUp = () => {
      isDown = false;
      cardContainer.classList.remove('active');
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - cardContainer.offsetLeft;
      const walk = (x - startX) * 2;
      cardContainer.scrollLeft = scrollLeft - walk;
    };

    const handleTouchStart = (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = cardContainer.scrollLeft;
    };

    const handleTouchMove = (e) => {
      const x = e.touches[0].pageX;
      const walk = (x - startX) * 2;
      cardContainer.scrollLeft = scrollLeft - walk;
    };

    cardContainer.addEventListener('mousedown', handleMouseDown);
    cardContainer.addEventListener('mouseleave', handleMouseLeave);
    cardContainer.addEventListener('mouseup', handleMouseUp);
    cardContainer.addEventListener('mousemove', handleMouseMove);
    cardContainer.addEventListener('touchstart', handleTouchStart);
    cardContainer.addEventListener('touchmove', handleTouchMove);

    return () => {
      cardContainer.removeEventListener('mousedown', handleMouseDown);
      cardContainer.removeEventListener('mouseleave', handleMouseLeave);
      cardContainer.removeEventListener('mouseup', handleMouseUp);
      cardContainer.removeEventListener('mousemove', handleMouseMove);
      cardContainer.removeEventListener('touchstart', handleTouchStart);
      cardContainer.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);




  return (
    <>
      <div className='home-container'>
        <Navbar />
        <div className='farm-calculator-hero'>
          {/* <img src="/assets/birds_group.svg" alt="Down Arrow"/> */}
          <span>
            <PoultryCompileIcon />
          </span>
          <div>
            <h1 className='title'>Farm Calculator</h1>
            <p className='subTitle'>Estimate accurately, your poultry production on the go!</p>
          </div>
        </div>

        <div ref={cardContainerRef} className='card-container'>
          <div className='card-wrapper'>
            <div className='first-card'>              
              <div className='poultry'><p>Poultry</p></div>
              <div className='card-inner-section'>
                <img src="/assets/pond_trees.svg" alt="park with a pond and trees" className='card-image'/>
                <div className='card-title-section'>
                  <h3 className='card-title'>My Space Calculator</h3>
                  <p className='card-sub-title'>Calculate how much space you need for your poultry birds or how many birds can fit in your space.</p>
                  <Link to='/space-calculator'>
                    <button className='button'>Open Calculator</button>
                  </Link>
                  
                </div>
              </div>
            </div>
            <div className='second-card'>
              <div className='poultry'><p>Poultry</p></div>
              <div className='card-inner-section'>
                <img src="/assets/hay.svg" alt="hay" className='card-image'/>
                <div className='card-title-section'>
                  <h3 className='card-title'>Feed Calculator</h3>
                  <p className='card-sub-title'>Calculate how much feed & water your flock requires, including timeline for different feed types and daily servings.</p>
                  <Link to='/feed-calculator'>
                    <button className='button'>Open Calculator</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className='third-card'>
              <div className='poultry'><p>Poultry</p></div>
              <div className='card-inner-section'>
                <img src="/assets/eggs_shell.png" alt="egg" className='card-image'/>
                <div className='card-title-section'>
                  <h3 className='card-title'>Egg Calculator</h3>
                  <p className='card-sub-title'>Estimate how much eggs you can  generate from any number of poultry birds based on their age, breed etc.</p>
                  <Link to='/egg-calculator'>
                    <button className='button'>Open Calculator</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className='fourth-card'>
              <div className='poultry'><p>Poultry</p></div>
              <div className='card-inner-section'>
                <img src="/assets/syringe.png" alt="syringe" className='card-image'/>
                <div className='card-title-section'>
                  <h3 className='card-title'>Vaccine Calculator</h3>
                  <p className='card-sub-title'>Estimate how much of any type of vaccine you need for your poultry birds.</p>
                  <Link to='/vaccine-calculator'>
                    <button className='button'>Open Calculator</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='help-container'>
          <div className='help-title-container'>
            <h3 className='help-title'>Our calculators help you</h3>
          </div>
          <div className='help-card-container'>
            <div className='help-card'>
              <div className='help-image-container'>
                <img src="/assets/ph_farm.png" alt="farm" className='help-image'/>
              </div>
              <p className='help-sub-title'>Plan</p>
            </div>
            <div className='help-card'>
              <div className='help-image-container'>
                <img src="/assets/entypo_feather.png" alt="feather" className='help-image'/>
              </div>
              <p className='help-sub-title'>Estimate</p>
            </div>
            <div className='help-card'>
              <div className='help-image-container'>
                <img src="/assets/ic_sharp.png" alt="secure" className='help-image'/>
              </div>
              <p className='help-sub-title'>Forecast</p>
            </div>
          </div>
        </div>

        <Footer/>
      </div>

    </>
  );
};


export default FarmCalculator;
